import { api } from '../../../shared/api'
import type { User } from '../../auth/types'

export interface RoleOption {
  id: string
  title: string
  description: string
  icon: string
}

export interface RoleUpdateRequest {
  role: 'ADMIN' | 'OWNER' | 'MANAGER' | 'RESIDENT'
}

export interface RoleUpdateResponse {
  success: boolean
  message: string
  data: {
    user: User
  }
}

export interface AvailableRolesResponse {
  success: boolean
  data: {
    roles: RoleOption[]
  }
}

export const roleApi = {
  // Get available roles for onboarding
  getAvailableRoles: async (): Promise<RoleOption[]> => {
    const res = await api.get<AvailableRolesResponse>('/role/available')
    return res.data.roles
  },

  // Update user role
  updateUserRole: async (role: RoleUpdateRequest): Promise<User> => {
    const res = await api.post<RoleUpdateResponse>('/role/update', role)
    return res.data.user
  }
}
